<template>
<v-app>
    <v-card flat>
        <div style="height: 0px; display: block; position: absolute; width: 100%;">
            <v-progress-linear color="blue" :indeterminate="true" v-if="loading"></v-progress-linear>
        </div>

        <v-card-title><span class="headline">Виконавці :: {{title}}</span></v-card-title>

        <v-container fluid pa-4 fluid>
            <v-layout row wrap>
                <v-flex xs1>
                    <v-text-field label="ID" readonly v-model="f.id"></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-text-field label="Назва" v-model="f.name" data-vv-name="name" data-vv-as="Назва" v-validate="'required'" :error-messages="errors.collect('name')"></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-text-field label="Назва (реєстрація)" v-model="f.companyName" data-vv-name="companyName" data-vv-as="Назва (реєстрація)" v-validate="'required'" :error-messages="errors.collect('companyName')"></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-textarea label="Реквізити" v-model="f.essentialInfo"></v-textarea>
                </v-flex>
                <v-flex xs12>
                    <v-text-field label="Адреса для кореспонденції" v-model="f.address"></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-text-field label="Адреса для запчастин" v-model="f.address2"></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-text-field label="Статус СЦ" v-model="f.statusSc"></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-menu  ref="menu" v-model="menu" :close-on-content-click="false" :nudge-right="40" :return-value.sync="f.createScDate" lazy transition="scale-transition" offset-y full-width min-width="290px">
                        <v-text-field slot="activator" v-model="f.createScDate" label="Дата заснування СЦ" prepend-icon="event" readonly ></v-text-field>
                        <v-date-picker v-model="date" no-title scrollable locale="uk" @input="$refs.menu.save(date)">
                        </v-date-picker>
                    </v-menu>
                </v-flex>
                <v-flex lg6 xs12>
                    <v-text-field label="Можливість роботи з газом – холодильники/кондиціонери" v-model="f.possibilityR600"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                    <v-text-field label="Можливість роботи з газом – газові плити" v-model="f.possibilityOven"></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-textarea label="Наявність ліцензій та дозволів на проведення робіт" v-model="f.licenseAvailability"></v-textarea>
                </v-flex>
                <v-flex xs12>
                    <v-textarea label="Транспортні засоби" v-model="f.transport"></v-textarea>
                </v-flex>
                <v-flex xs12>
                    <v-textarea label="ТМ, які обслуговуються за контрактом першого рівня" v-model="f.tradeMarks"></v-textarea>
                </v-flex>
                <v-flex xs12>
                    <v-textarea label="Обладнання для ремонту ВПТ" v-model="f.equipmentVPT"></v-textarea>
                </v-flex>
                <v-flex xs12>
                    <v-textarea label="Обладнання для ремонту ВПТ" v-model="f.equipmentCond"></v-textarea>
                </v-flex>
            </v-layout>
        </v-container>

        <v-card-actions>
            <v-card flat>
                <v-card-text>
                    <v-btn color="primary" @click="submitForm()" :disabled="loading">зберегти</v-btn>
                </v-card-text>
            </v-card>

            <v-progress-circular indeterminate v-if="loading"></v-progress-circular>
        </v-card-actions>

        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="timeout">
            <v-icon color="white">{{snackbarIcon}}</v-icon> {{snackbarText}}
        </v-snackbar>

    </v-card>
</v-app>
</template>

<script>
import {
    HTTP
} from '../http-common'

export default {
    name: 'RepairCardTabMain',
    props: {
        title: String,
        id: Number
    },
    data: function () {
        return {
            f: {},
            error: [],
            snackbar: false,
            snackbarText: '',
            snackbarColor: '',
            snackbarIcon: '',
            timeout: 6000,
            loading: true,

            date: '',
            menu: false,
            menu1: false,
            menu2: false,
            menu3: false,
            menu4: false,
            picker: new Date().toISOString().substr(0, 10),
        }
    },
    methods: {
        submitForm() {
            this.$validator.validateAll().then(result => {
                this.loading = true
                this.snackbar = false
                if (result) {
                    HTTP.put('/contractors/update', {
                            fields: this.f
                        }).then(response => {
                            if (response.status == 200 && response.data && response.data.status != 'error') {
                                this.snackbarText = 'Успiшно збережено'
                                this.snackbarColor = 'info'
                                this.snackbarIcon = 'done_outline'

                            } else {
                                this.snackbarText = 'Помилка ' + response.data.error
                                this.snackbarColor = 'error'
                                this.snackbarIcon = 'error'
                            }

                        }).catch(e => {
                            this.snackbarText = 'Помилка: 500'
                            this.snackbarColor = 'error'
                            this.snackbarIcon = 'error'
                        })
                        .finally(
                            () => {
                                this.loading = false
                                this.snackbar = true
                            }
                        )
                } else {
                    this.loading = false
                    this.snackbarText = 'Виправте '
                    this.snackbarColor = 'error'
                    this.snackbarIcon = 'error'
                    this.snackbar = true

                }
            })
        },
    },
    watch: {},
    mounted() {},
    created() {
        HTTP.get(`contractors/view`, {
                params: {
                    id: this.$route.params.id
                }
            })
            .then(response => {
                if (response.data && response.data.data) {
                    this.f = response.data.data
                }
            })
            .catch(e => {
                this.error.push(e)
            })
            .finally(
                () => {
                    this.loading = false
                }
            )
    }

}
</script>

<style>
</style>
